export const CurrentInvoiceData = [
    {
        Overdue: 'Due This Month',
        DueToday: 'Not Due',
    }
]